<template>
    <!-- 轮播图 -->
    <van-swipe class="carousel" indicator-color="white" :autoplay="autoplay"
               :style="{...size}" @change="onChange"
    >
        <!-- 指示器 -->
        <template #indicator>
            <div class="custom-indicator">{{ current + 1 }}/{{list.length}}</div>
        </template>
        <van-swipe-item v-for="item in list" :key="item"
                        :width="size.width" :height="size.height"
                        @click="go(item)"
        >
            <div class="item" :style="{...size}">
                <van-image :width="size.width" :height="size.height"
                           :src="item.url" :alt="item.description || item.url"
                           :fit="fit"
                />
                <template v-if="showDescription && item.description">
                    <div class="mask"></div>
                    <div class="description"
                    >{{item.description}}</div>
                </template>
                <slot name="info"></slot>
            </div>
        </van-swipe-item>
    </van-swipe>
</template>

<script>
import {ref} from 'vue'
export default {
    name: "Carousel",
    props:{
        list:{
            type:Array,
            required:true,
            default: () => [],
        },
        autoplay:{
            default:5000,
        },
        size:{
            type:Object,
            default(){
                return{
                    width:'100vw',
                    height:'auto',
                }
            }
        },
        fit:{
            type:String,
            default:'fill',
        },
        showDescription:{
            type:Boolean,
            default:true,
        }
    },
    setup(){
        const current = ref(0)

        return{current}
    },
    methods:{
        go(item){
            if(item && item.link){
                const link = item.link
                switch (typeof link){
                    case "object":this.$router.push(link);return;
                    case "string":window.location = item.link;return;
                }
                console.warn(item.link)
            }
        },
        onChange(index){
            this.current = index;
            this.$emit('change',index)
        }
    }
}
</script>

<style scoped>
.carousel{
    display: inline-block;
}
.carousel .item{
    position: relative;
    background-color: #bbb;
}
.carousel .item > .mask{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    pointer-events: none;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5) 0%,transparent 30%);
}
.carousel .item > .description{
    position: absolute;
    left: 0;
    right: 30%;
    bottom: 0;
    color: #FFF;
    height: 6vw;
    padding: 0 0 5px 4vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
}
</style>
